import { __decorate } from "tslib";
import { field } from '@simonbackx/simple-encoding';
import { TinyMember } from './Member.js';
import { Registration } from './Registration.js';
export class RegistrationWithMember extends Registration {
    static from(registration, member) {
        return RegistrationWithMember.create({
            ...registration,
            member,
        });
    }
}
__decorate([
    field({ decoder: TinyMember })
], RegistrationWithMember.prototype, "member", void 0);
//# sourceMappingURL=RegistrationWithMember.js.map